import { formatWithMomentToken } from '@heidi/utils/dates';
import { endOfMonth } from 'date-fns';
import { useMemo } from 'react';
import type { CommerceBillingUiPorts } from '../settings/billing/billing-ui-ports';

/**
 * User quota and reset date derived from current user data.
 * Use this instead of reading userData?.quota in billing/settings components.
 */
export function useUserQuota(
  useQueryUser: CommerceBillingUiPorts['useQueryUser'],
  defaultDateFormat: string
) {
  const { data: userData } = useQueryUser((data) => ({
    quota: data?.quota,
    session_settings: data?.session_settings,
  }));

  const dateFormat = userData?.session_settings?.date_format ?? defaultDateFormat;
  // Computed outside useMemo so it stays correct if the page is open across a month boundary
  const quotaResetDate = formatWithMomentToken(endOfMonth(new Date()), dateFormat);

  return useMemo(
    () => ({
      quotaResetDate,
      inSessionQuotaRemaining: userData?.quota?.evidence_patient_or_session_linked,
      customNoteQuotaRemaining: userData?.quota?.ai_template,
      askAiQuotaRemaining: userData?.quota?.ask_ai,
      unlimitedQuotaUntil: userData?.quota?.unlimited_quota_until,
    }),
    [
      quotaResetDate,
      userData?.quota?.unlimited_quota_until,
      userData?.quota?.ai_template,
      userData?.quota?.evidence_patient_or_session_linked,
      userData?.quota?.ask_ai,
    ]
  );
}
